import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, message, Spin } from "antd";
import { makeApiRequest } from "../../shared/api";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isVerifying, setIsVerifying] = useState(true);

  console.log("Entry Okay or not");
  
  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get("session_id");
      console.log('Verifying payment for session:', sessionId);

      if (!sessionId) {
        message.error('Invalid payment session');
        navigate('/billing');
        return;
      }

      try {
        const response = await makeApiRequest("GET", `billing/payment/${sessionId}`);
        console.log('Verification response:', response);

        if (response?.status === "complete") {
          const quotaResponse = await makeApiRequest("GET", "billing/quota");
          console.log('Quota response:', quotaResponse);

          await makeApiRequest("GET", "billing/activities");
          
          message.success("Payment verified successfully!");
          setIsVerifying(false);
        } else {
          throw new Error('Payment verification incomplete');
        }
      } catch (error) {
        console.error("Verification error:", error);
        message.error("Failed to verify payment");
        navigate('/billing');
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  if (isVerifying) {
    return (
      <div style={styles.container}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        <p style={styles.text}>Verifying your payment...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <CheckCircleOutlined style={styles.icon} />
      <h1 style={styles.title}>Payment Successful!</h1>
      <p style={styles.text}>Thank you for your purchase. Your transaction was successful.</p>
      
      <Button type="primary" size="large" onClick={() => navigate("/billing")}>
        Return to Billing
      </Button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
  },
  icon: {
    fontSize: "64px",
    color: "#52c41a",
    marginBottom: "24px",
  },
  title: {
    fontSize: "24px",
    marginBottom: "16px",
  },
  text: {
    fontSize: "16px",
    marginBottom: "24px",
  },
};

export default PaymentSuccess;